import { render, staticRenderFns } from "./BadgeComponent.vue?vue&type=template&id=0a620e28&"
import script from "./BadgeComponent.vue?vue&type=script&lang=ts&"
export * from "./BadgeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeComponent.vue?vue&type=style&index=0&id=0a620e28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports